import { useSelector } from "react-redux"
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { FormatoFechaIso } from "./../../../utils/FormatFecha"
import { formatDinero } from "./../../../utils/formatDinero"
const useStyles = makeStyles({
  root: {
    margin: "10px 0"
  },
  table: {
    minWidth: 650,
  },
});

const TablaDCliente = () => {
  const classes = useStyles()
  const { cliente, viaje,diasRestantes } = useSelector(store => store.cambios)
  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Titular</TableCell>
            <TableCell align="center">Usuario</TableCell>
            <TableCell align="center">Paquete</TableCell>
            <TableCell align="center">Num. Pax</TableCell>
            <TableCell align="center">Fecha Salida</TableCell>
            <TableCell align="center">Días restantes</TableCell>
            <TableCell align="center">Monto Ahorrado</TableCell>
            <TableCell align="center">Monto Paquete</TableCell>
            <TableCell align="center">Estatus</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow >
            <TableCell align="center" component="th" scope="row">
              {
               cliente?.Titular ?? `No Aplica`
              }
            </TableCell>
            <TableCell align="center" component="th" scope="row">
              {
              `${viaje.Cuenta?.Nombre.trim()} ${viaje.Cuenta?.Apellido_Paterno.trim()}`
              }
            </TableCell>
            <TableCell align="center">
              {
                viaje.Paquete?.Nombre
              }
            </TableCell>
            <TableCell align="center">
              {
                viaje.Paquete?.Numero_Personas
              }
            </TableCell>
            <TableCell align="center">
              {
                FormatoFechaIso({ date: viaje.Paquete?.Fecha_Viaje, formato: 'dd MMMM yyy' })
              }
            </TableCell>
            <TableCell align="center">
              {
                diasRestantes
              }
            </TableCell>
            <TableCell align="center">
            {
                `${formatDinero(viaje.Suma)} ${viaje.Moneda?.Clave}`
              }
            </TableCell>
            <TableCell align="center">
              {
                `${formatDinero(viaje.Paquete?.Monto_Paquete)} ${viaje.Moneda?.Clave}`
              }
            </TableCell>
            <TableCell align="center">
              {
                 `${viaje.Paquete?.CatEstatusProceso.Descripcion}`
              }
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
export default TablaDCliente